// extracted by css-extract-rspack-plugin
export default {"markdownOverrides":"MarkdownViewer-module__markdownOverrides__sSQCQ"};